import React, { useCallback } from 'react'
import { ModalCloseButton } from '@chilipiper/design-system'

interface CloseButtonProps {
  closeRedirect?: string
  component: string
  inIframe: boolean
  processRedirect: string
}

export const CloseButton = ({
  component,
  processRedirect,
  closeRedirect,
  inIframe,
}: CloseButtonProps) => {
  const closePopup = useCallback(() => {
    const redirect = component === 'booked' ? processRedirect : closeRedirect
    if (redirect) {
      if (window.parent?.postMessage && inIframe) {
        window.parent.postMessage(
          {
            action: 'REDIRECT',
            url: redirect,
          },
          '*'
        )
      } else {
        window.location.replace(redirect)
      }
    } else if (window.parent) {
      window.parent.postMessage({ action: 'close', args: [] }, '*')
      if (component === 'intermidiate') {
        window.parent.postMessage({ action: 'no-action-choice' }, '*')
      }
    }
  }, [closeRedirect, component, processRedirect, inIframe])

  return <ModalCloseButton onClose={closePopup} />
}
